
    // this file was auto generated by python script
    import Check from './Check';
    export default Check;
    